import {serviceApiHostName} from "../../endpoint";
import {defaultHeaders} from "../../headers";

export const deleteService = async (id) => {
  try {
    const result = await fetch(`${serviceApiHostName}/service/${id}`, {
      method: "DELETE",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (error) {
    return {
      hasSuccess: false,
      data: error.message,
    };
  }
};
